import React from 'react';
import { PageHeader } from './About';
import { business } from '../data/siteData';

export default function PrivacyPolicy() {
  return (
    <div>
      <PageHeader
        title="Privacy Policy"
        subtitle="Your privacy is important to us. This policy explains what information we collect and how we use it."
        crumb="Privacy Policy"
      />

      <section className="max-w-4xl mx-auto px-6 py-16 prose-content">
        <p className="text-sm text-slate-500">
          Last updated: {new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <h2>1. Introduction</h2>
        <p>
          {business.name} (“we”, “our” or “us”) operates the website at this domain. This
          Privacy Policy describes how we collect, use, and disclose information that we obtain
          about visitors to our website and customers who contact us regarding our asphalt paving,
          seal coating, crack sealing and related construction services.
        </p>

        <h2>2. Information We Collect</h2>
        <p>
          We collect information that you voluntarily provide to us when you call our office or
          inquire about our services, including your name, phone number, project location and
          project details. We also automatically collect limited technical information such as
          your IP address, browser type, referring page and pages visited on our website. We do
          not knowingly collect personal information from children under the age of 13.
        </p>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To respond to your inquiries and provide service quotes.</li>
          <li>To schedule, deliver and follow up on construction services.</li>
          <li>To improve our website, services and customer experience.</li>
          <li>To comply with legal obligations, accounting and warranty records.</li>
        </ul>

        <h2>4. Cookies and Tracking Technologies</h2>
        <p>
          Our website may use cookies, pixels and similar technologies (including those from
          advertising partners such as Meta Ads / Facebook Pixel and Google Analytics) to
          understand how visitors interact with our site, to measure the effectiveness of our
          marketing campaigns, and to display relevant ads. You can control or disable cookies
          through your browser settings.
        </p>

        <h2>5. Advertising</h2>
        <p>
          We may work with third-party advertising platforms to reach potential customers in our
          service area. These platforms may use information collected on our website to show you
          ads about our services on their own platforms. We do not sell your personal
          information.
        </p>

        <h2>6. Sharing of Information</h2>
        <p>
          We do not sell, rent or trade your personal information. We may share information with
          trusted service providers (such as hosting providers, analytics providers and
          advertising platforms) who help us operate our business, or when required by law.
        </p>

        <h2>7. Data Security</h2>
        <p>
          We use reasonable technical and organisational safeguards to protect the information we
          collect. However, no method of transmission over the Internet is 100% secure.
        </p>

        <h2>8. Your Rights</h2>
        <p>
          Subject to applicable Canadian privacy legislation, including PIPEDA, you may have the
          right to access, correct or request deletion of personal information we hold about you.
          To make such a request, please contact us by phone at{' '}
          <a href={`tel:${business.phoneRaw}`} className="text-amber-600 font-semibold">
            {business.phone}
          </a>.
        </p>

        <h2>9. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the
          privacy practices or content of those websites.
        </p>

        <h2>10. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with a revised “Last updated” date.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or our privacy practices, please
          contact us at:
        </p>
        <p>
          <strong>{business.name}</strong>
          <br />
          {business.address}
          <br />
          Phone:{' '}
          <a href={`tel:${business.phoneRaw}`} className="text-amber-600 font-semibold">
            {business.phone}
          </a>
          <br />
          Email:{' '}
          <a href={`mailto:${business.email}`} className="text-amber-600 font-semibold break-all">
            {business.email}
          </a>
        </p>
      </section>

      <style>{`
        .prose-content h2 {
          font-size: 1.4rem;
          font-weight: 800;
          color: #0f172a;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
        }
        .prose-content p, .prose-content li {
          color: #475569;
          line-height: 1.7;
          margin-bottom: 0.75rem;
        }
        .prose-content ul {
          padding-left: 1.25rem;
          list-style: disc;
          margin-bottom: 1rem;
        }
      `}</style>
    </div>
  );
}
